export default class BaseRegulation {
    public setup() {}

    public gameReady() {}

    public interactionStart() {}

    public updateNetPosition(netPosition: number) {}
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/regulations/base-regulation.ts